<section class="pt-4 px-2 px-lg-0">
	<h2>{{ "footer.termsConditions" | translate }}</h2>
	<div
		class="free-text-page pt-3"
		[innerHTML]="'termini-condizioni.html-full' | translate | safeHtml"
	></div>
</section>